import { render, staticRenderFns } from "./Addnew_service.vue?vue&type=template&id=8c273eca&scoped=true&"
import script from "./Addnew_service.vue?vue&type=script&lang=js&"
export * from "./Addnew_service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c273eca",
  null
  
)

export default component.exports